export const ALL_JOB = "job/allJob";

export const ALL_STAT = `${process.env.REACT_APP_API_URL}stat/all`;
export const SIGNUP_API = "auth";
export const EVERIFY_API = "https://everify.ooshlink.com/login";
export const EDIRECT_API = "https://auth.edirect.ng/api/auth/register";
export const SIGIN_URL = "auth/signin";
export const JOB_API = "job/getAjob";
export const JOB_URL = "job";
export const APPLICATION_API = "application";
export const INTERVIEW_API = "interview";
export const BENEFIT_API = "benefit";
export const OFFER_API = "offer";
export const PAYMENT_API = "payment";
export const BLACKLIST_API = "blacklist";

// ------ profile section --------
export const EDUCATION_URL = "education";
export const WORK_URL = "experience";
export const CERTIFICATE_URL = "certificate";
export const GUARANTOR_URL = "guarantor";
export const JOBSEEKER_URL = "jobSeeker";

// ----- profile section employer -------
export const CONTACT_PERSON_URL = "contactPerson";
export const EMPLOYER_URL = "jobrecruiter";
export const EXISTENCE_PROOF_URL = "proof";
export const ADDRESS_PROOF_URL = "addressProof";
export const HIRED = "hired";
export const SEND_MESSAGE = "sendMessage";
export const CANDIDATE_URL = "candidate";



export const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
export const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
export const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
export const EMAILJS_PRIVATE_KEY = process.env.REACT_APP_EMAILJS_PRIVATE_KEY;
